import { Component, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common'
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { APIService } from '../fleet-management/backend-service/backend-service';
import { SharedService } from '../share-data/shared.service';
import { NotificationService } from '../shared/services/notification.service';
import { LoadingService } from '../services/loading.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../fleet-management/transport-management/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-consignee-registration',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatRadioModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './consignee-registration.component.html',
  styleUrl: './consignee-registration.component.scss'
})
export class ConsigneeRegistrationComponent implements OnDestroy {
  selectedConsigneeId: string | null = null;
  dropdownPosition = { top: '0px', right: '0px' };
  searchText: string = '';
  datas: any[] = [];
  latitude = 10.7769;
  longitude = 106.7009;
  currentPage: number = 1;
  totalPages: number = 1;
  pageSize: number = 10;
  pages: number[] = [];
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  get googleMapsLink() {
    return `https://www.google.com/maps?q=${this.latitude},${this.longitude}`;
  }

  constructor(private router: Router, private apiService: APIService, private sharedService: SharedService,
    private notification: NotificationService,
    public loadingService: LoadingService,
    private dialog: MatDialog) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }

  ngOnInit() {
    this.getConsigneeList();
  }
  get pagedOrders() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.filteredOrders.slice(start, start + this.pageSize);
  }
  addNewConsignee() {
    this.router.navigate(['/home/consignee-registration/register-form']);
  }

  get filteredOrders() {
    if (!this.searchText) {
      return this.datas;
    }
    const searchLower = this.searchText.toLowerCase();
    return this.datas.filter(data => {
      const name = data.name?.toLowerCase() || '';
      const contactName = data.contactName?.toLowerCase() || '';
      const primaryContact = data.primaryContact || '';
      const address = data.address?.toLowerCase() || '';
      return name.includes(searchLower) ||
        contactName.includes(searchLower) ||
        primaryContact.includes(this.searchText) ||
        address.includes(searchLower);
    });
  }

  getConsigneeList(page: number = 1) {
    this.datas = [];
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    this.apiService.get(`/api/consignees?page=${page}&limit=${this.pageSize}`, loginData.token).subscribe({
      next: (response) => {
        console.log('/api/consignee/list' + ',\n' + 'Consignee_List_Response:', response.body);
        if (response.status === 200) {
          this.datas = response.body.consignees.map((c: any) => {
            const defaultLocation = c.locations?.find((l: any) => l.isDefault) ?? c.locations?.[0];
            const primaryContact = defaultLocation?.contacts?.find((ct: any) => ct.isPrimary) ?? defaultLocation?.contacts?.[0];
            return {
              ...c,
              contactName: primaryContact?.contactName ?? null,
              primaryContact: primaryContact?.phoneNumber ?? null,
              address: defaultLocation?.address ?? null,
            };
          });
          this.totalPages = response.body.pagination.totalPages;
          this.pages = Array(this.totalPages).fill(0).map((_, i) => i + 1);
          this.currentPage = page;
        }
        else {
          console.log("Hey you")
        }
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }
  editConsignee(data: any, event: MouseEvent) {
    console.log("Selected Id: ", data.id)
    if (this.selectedConsigneeId === data.id) {
      this.selectedConsigneeId = null;
    } else {
      const btn = event.currentTarget as HTMLElement;
      const rect = btn.getBoundingClientRect();
      this.dropdownPosition = {
        top: `${rect.bottom + 4}px`,
        right: `${Math.max(window.innerWidth - rect.right, 8)}px`,
      };
      this.selectedConsigneeId = data.id;
    }
  }
  onEdit(data: any) {
    this.selectedConsigneeId = null;
    this.sharedService.setData(data);
    this.router.navigate(
      ['/home/consignee-registration/consignee-form/:id'],
      { queryParams: { isEdit: true } }
    );
  }

  onDelete(data: any) {
    this.selectedConsigneeId = null;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '420px',
      data: { plateNumber: data.name, title: 'Delete Consignee', confirmLabel: 'Delete', message: 'Are you sure you want to delete consignee' }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.deleteConsignee(data);
      }
    });
  }
  deleteConsignee(data: any) {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    this.apiService.delete('/api/consignees/' + data.id, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/consignees/delete' + ',\n' + 'Consignee_Delete_Response:', response);
        if (response.status === 200) {
          this.datas = response.body;
        }
        else {
          console.log("Hey you")
        }
        this.notification.success(response.message || 'Operation completed successfully');
        this.getConsigneeList();
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Only close the dropdown if clicked outside any dropdown-related button or menu
    if (!target.closest('.btn-icon-action') && !target.closest('.dropdown-menu')) {
      this.selectedConsigneeId = null;
    }
  }
}
